var latestVolume = function (volumes, matches) {
    var matching = volumes.filter(matches);
    return matching[matching.length - 1];
};
// volumes come sorted by date, so the last one is the latest; a free special issue is the usual counterpart of a monograph
export var defaultVolumeId = function (volumes) {
    var _a, _b, _c, _d;
    return (_d = (_c = ((_b = (_a = latestVolume(volumes, function (volume) { return volume.freeSpecialCount > 0; })) !== null && _a !== void 0 ? _a : latestVolume(volumes, function (volume) { return volume.linkableCount > 0; })) !== null && _b !== void 0 ? _b : volumes[volumes.length - 1])) === null || _c === void 0 ? void 0 : _c.volumeId) !== null && _d !== void 0 ? _d : "";
};
